import React from 'react';

const PageContainer = ({ className = '', children }) => {
  return <div className={`page-container ${className}`.trim()}>{children}</div>;
};

export default PageContainer;

